import { Component, OnInit, HostListener, AfterViewInit, Inject, OnDestroy } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { RealTimeNotificationService } from '@shared/services/realTimeNotification/real-time-notification.service';
import { SignalrService } from '@app/core/signalr.service';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { environment } from '@env/environment';
import { Logger, I18nService } from '@app/core';
import { NotificationsService } from '@shared/services/notifications.service';
import { Notification } from '@app/core/types/notifications';
import { ToastService } from '@shared/services/toast/toast.service';
import { RoutesRecognized, Event } from '@angular/router';
import { NgxPermissionsService, NgxPermissionsObject } from 'ngx-permissions';
import { Identifiers } from '@shared/services/app.config.type';
// import { read } from 'fs';
import { firstValueFrom, forkJoin, Subscription, tap } from 'rxjs';
import { identityServerAngularConfig } from '@env/environment';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from '@projects/shared/src/app/modules/dynamicdialog';
import { AuthServiceCleaner } from '@shared/services/auth.service.cleaner';
import { IdleTimeoutService } from '@shared/services/idle-timeout.service';
import { BroadcastChannel } from 'broadcast-channel';
import { LoaderService } from './core/loader.service';
import { SessionMessageComponent } from './auth/login/session-message/session-message.component';
import { TelephonyProvider } from '@projects/shared/src/app/providers/telephony/telephony.provider';
import { Constants } from './constants';
import { CampaignService } from '@projects/shared/src/app/services/campaign.service';
import { RealTimeEvents } from './core/signalr.events';
import { CheckPermission, momentCustomInstance as moment } from '@projects/shared/src/app/utils/helper';
import { ProviderService } from '@projects/shared/src/app/services/provider.service';
import { IntegrationService } from '@projects/shared/src/app/services/integration.service';
import { ConversationService } from '@projects/shared/src/app/features/chat/services/conversation/conversation.service';
import { BundleDealerService } from '@projects/shared/src/app/services/bundle-dealer.service';
import { ConnectionService, ConnectionState } from '@projects/shared/src/app/services/network.service';
import { AlertService } from '@projects/shared/src/app/services/alert.service';
const log = new Logger('App');

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [DialogService, DynamicDialogRef, DynamicDialogConfig],
})
export class AppComponent implements OnInit, OnDestroy {
  // NotificationUpdateInterval = 60000;
  Interval: any;
  status: string = '';
  ReadNotificationCount = 50;
  permissions!: NgxPermissionsObject;
  isPortalTrafficDataPushAllowed!: boolean;
  notificationApiRequestinProcess!: boolean;
  _localStorageKey = 'idle_timeout_countdown_last_reset_timestamp';
  _isTimerEnabledKey = 'idle_timeout_enabled';
  _idleSecondsTimer: any = null;
  _lastResetTimeStamp: any;
  _localStorage: any = null;
  _clockTimer: any = null;
  _clockTimerKey = 'clock_timer';
  _redirectClockTimerKey: any = null;
  _timerCount = 0;
  _isCurrentActive = false;
  channel!: BroadcastChannel<any>;
  CHANNEL_NAME = 'broadcast-channel';
  isRefreshing = false;
  subscriptions = new Array<Subscription>();
  clientId: string;

  constructor(
    private router: Router,
    private toast: ToastService,
    private translateService: TranslateService,
    private realTimeNotificationService: RealTimeNotificationService,
    private telephonyProvider: TelephonyProvider,
    public authService: AuthenticationService,
    public dialogService: DialogService,
    public ref: DynamicDialogRef,
    private authClearService: AuthServiceCleaner,
    public idleTimeoutService: IdleTimeoutService,
    public config: DynamicDialogConfig,
    public loaderService: LoaderService,
    private notificationService: NotificationsService,
    public toastService: ToastService,
    public ngxPermission: NgxPermissionsService,
    private campaignService: CampaignService,
    private signalRService: SignalrService,
    @Inject(DOCUMENT) private document: Document,
    private providerService: ProviderService,
    private integrationService: IntegrationService,
    private conversationService: ConversationService,
    private alertService: AlertService
  ) {
    this.clientId = this.authService.getClientId();

    if (!this.authService.isAuthenticated()) {
      let isIdleTimeout = JSON.parse(localStorage.getItem('isIdleTimeout') || 'null');
      let isUserReloggedIn = JSON.parse(localStorage.getItem('isUserReloggedIn') || 'null');
      if (isIdleTimeout && isIdleTimeout == true) {
        localStorage.removeItem('isIdleTimeout');
        this.router.navigate(['idle-timeout']);
      } else if (isUserReloggedIn && isUserReloggedIn == true) {
        localStorage.removeItem('isUserReloggedIn');
        this.router.navigate(['post-logout']);
      } else {
        if (location.pathname.includes('signin-callback')) {
        } else if (!this.authService.isNoAuthUrl()) {
          this.router.navigate(['login']);
        }
      }
    } else {
      this.authService.isLoggedIn = true;
    }
    // this.breadCrumbService.init(router, activatedRoute);

    router.events.subscribe((event: Event) => {
      if (event instanceof NavigationStart) {
        if (!router.navigated) {
          const callSid = localStorage.getItem('activeCallSid');
          this.markCallForceDispose(callSid);
        }
      }
      if (event instanceof NavigationEnd) {
        if (event.url === '/') {
          this.routeDecider();
        }
      } else if (event instanceof RoutesRecognized) {
        let childRoute: any = event.state.root.firstChild;
        while (childRoute != null) {
          if (childRoute.data.pageName != null) {
            let pageName = '';
            let moduleName = '';
            if (childRoute.firstChild?.data?.pageName) {
              pageName = childRoute.firstChild.data.pageName;
              moduleName = childRoute.data.module;
            } else {
              pageName = childRoute.data.pageName;
              moduleName = childRoute.data.module;
            }
            this.notificationService.ActivityRoutingNotification('Visit', pageName, moduleName);
            break;
          }
          childRoute = childRoute.firstChild;
        }
      }
    });
  }
  ngOnDestroy(): void {
    this.subscriptions.forEach((x) => {
      x.unsubscribe();
    });
  }

  onApply(e: any) {}

  /*
 @HostListener('window:beforeunload', ['$event'])
 unloadHandler(event: Event) {
     if (localStorage.getItem('loginNotificationId') != null) {
     const dateTime = new Date();
     let sessionData: any;
     if (localStorage.getItem('sessionsTab') == null) {
         sessionData = [];
     } else {
         sessionData = JSON.parse(localStorage.getItem('sessionsTab'));
     }
     const obj: any = {};
     obj.sessionId = this.notificationService.sessionId;
     obj.Date = dateTime;
     sessionData.push(obj);
     localStorage.setItem('sessionsTab', JSON.stringify(sessionData));
     console.log(new Date().toLocaleString() + '  ➤  In record');
 }
 }
 */
  @HostListener('window:scroll', ['$event']) // for window scroll events
  onScroll(event: any) {
    const a: any = document.querySelector('.p-dropdown-panel.p-component');
    if (a) {
      a.parentNode.removeChild(a);
      const pd: any = document.querySelector('.modal-dropdown');
      if (pd) {
        pd.firstElementChild.click();
      }
    }
  }

  ngOnInit() {
    this.subscriptions.push(
      this.signalRService.listen(RealTimeEvents.ForceLogout).subscribe((payload: any) => {
        console.log(`Force logg of event received for user ${payload.userId}`);
        const userId = this.authService.authData.Id;
        if (payload.userId != userId) return;
        this.toastService.info('Logging Out, Please wait...');
        localStorage.removeItem('last_status');
        localStorage.setItem('isForceLogout', 'true');
        localStorage.removeItem('last_status');
        const callSid = localStorage.getItem('activeCallSid');
        if (callSid) {
          this.markCallForceDispose(callSid);
          this.telephonyProvider.voice.forceDisposedAndLogout(null, callSid, true);
        }
        setTimeout(() => {
          this.router.navigate(['logout']);
        }, 500);
      })
    );

    this.subscriptions.push(
      this.signalRService.listen(RealTimeEvents.CustomerChatEndNotification).subscribe((data: any) => {
        if (this.clientId != data.clientId) return;

        if (CheckPermission('insights', 'insights_chat', this.authService)) {
          this.toast.info(`Chat completed by Customer.`);
        }
      })
    );

    this.subscriptions.push(
      this.signalRService.listen(RealTimeEvents.AgentChatComplete).subscribe((data: any) => {
        if (this.clientId != data.clientId) return;

        if (CheckPermission('insights', 'insights_chat', this.authService)) {
          this.toast.info(`Chat completed by Agent.`);
        }
      })
    );

    this.subscriptions.push(
      this.signalRService.listen(RealTimeEvents.IncomingChatAcceptedNotification).subscribe((data: any) => {
        if (this.clientId != data.clientId) return;
        if (CheckPermission('insights', 'insights_chat', this.authService)) {
          console.log(`Signal event => IncomingChatAcceptedNotification received with data`, data);
          this.toast.info(`${data.friendlyName} accepted by Agent.`);
        }
      })
    );

    this.subscriptions.push(
      this.signalRService.listen(RealTimeEvents.RatingNotification).subscribe((data: any) => {
        if (this.clientId != data.clientId) return;
        if (CheckPermission('insights', 'insights_chat', this.authService)) {
        }
      })
    );

    this.subscriptions.push(
      this.signalRService.listen(RealTimeEvents.OfflineMessageNotification).subscribe((data: any) => {
        if (this.clientId != data.clientId) return;
        if (CheckPermission('insights', 'insights_chat', this.authService)) {
          console.log(`Signal event => OfflineMessageNotification received with data`, data);
          this.toast.info(`New Offline message.`);
        }
      })
    );

    this.subscriptions.push(
      this.signalRService.listen(RealTimeEvents.HandoverChat).subscribe((data: any) => {
        if (this.clientId != data.clientId) return;
        if (CheckPermission('insights', 'insights_chat', this.authService)) {
          console.log(`Signal event => HandoverChat received with data`, data);
          this.toast.info(`Chat Handover to other agent.`);
        }
      })
    );

    this.subscriptions.push(
      this.signalRService.listen(RealTimeEvents.IncomingChatNotification).subscribe((data: any) => {
        if (this.clientId != data.clientId) return;
        if (CheckPermission('insights', 'insights_chat', this.authService)) {
          console.log(`Signal event => IncomingChatNotification received with data`, data);
          this.toast.info(`New Incoming Chat from ${data.customerInfo.siteUrl}.`);
        }
      })
    );

    const language = I18nService.getCurrentLocale();
    if (language !== undefined && language !== null) {
      this.document.documentElement.lang = language.split('-')[0].trim();
    }

    window.addEventListener('beforeunload', async (event: any) => {
      let lastStatus = localStorage.getItem('last_status');
      console.log(new Date().toLocaleString() + '  ➤  beforeunload fires');
      if (this.authService.isAuthenticated()) {
        let user = this.authService.authData;
        const features = user.Features;
        const isAgent = features.find((x: any) => x.Name === 'agent');
        if (isAgent && user.Campaigns?.length > 0) {
          //only sent away event is there is a last status and multi tab signalr modal is not opened
          if (lastStatus != null && !this.signalRService.isMultiTabOpen) {
            this.sendAwayEvent(Constants.STATUSES.Away.FriendlyName);
          } else if (lastStatus != null) this.authService.onlogout.next(Constants.STATUSES.Away.FriendlyName);
          const callSid = localStorage.getItem('activeCallSid');
          if (callSid) {
            this.markCallForceDispose(callSid);
            this.telephonyProvider.voice.forceDisposedAndLogout(null, callSid, true);
          }
          try {
            window.HangUpCall();
            if (window.registerSession) {
              window.AsteriskDisconnect();
            }
          } catch (error) {
            console.log(error);
          }
        }
      }

      window.clearInterval(this._idleSecondsTimer);
      window.clearInterval(this._clockTimer);
      window.clearInterval(this._redirectClockTimerKey);

      // Disconnedt SignalR properly
      // if (this.signalRService.isConnected()) {
      //   this.signalRService.disconnect();
      // }

      if (window.localStorage.getItem('loginNotificationId') != null) {
        const dateTime = new Date();
        let sessionData: any;
        if (window.localStorage.getItem('sessionsTab') == null) {
          sessionData = [];
        } else {
          sessionData = JSON.parse(window.localStorage.getItem('sessionsTab') || 'null');
        }
        const obj: any = {};
        obj.sessionId = this.notificationService.sessionId;
        obj.Date = dateTime;
        sessionData.push(obj);
        window.localStorage.setItem('sessionsTab', JSON.stringify(sessionData));
        log.debug('In record');
      }
    });
    this.routeDecider();
    if (!Array.prototype.forEach) {
      Array.prototype.forEach = function (callback: any /*, thisArg*/) {
        let T, k;

        if (this == null) {
          throw new TypeError('this is null or not defined');
        }

        // 1. Let O be the result of calling toObject() passing the
        // |this| value as the argument.
        const O = Object(this);

        // 2. Let lenValue be the result of calling the Get() internal
        // method of O with the argument "length".
        // 3. Let len be toUint32(lenValue).
        const len = O.length;

        // 4. If isCallable(callback) is false, throw a TypeError exception.
        // See: http://es5.github.com/#x9.11
        if (typeof callback !== 'function') {
          throw new TypeError(callback + ' is not a function');
        }

        // 5. If thisArg was supplied, let T be thisArg; else let
        // T be undefined.
        if (arguments.length > 1) {
          T = arguments[1];
        }

        // 6. Let k be 0.
        k = 0;

        // 7. Repeat while k < len.
        while (k < len) {
          let kValue;

          // a. Let Pk be ToString(k).
          //    This is implicit for LHS operands of the in operator.
          // b. Let kPresent be the result of calling the HasProperty
          //    internal method of O with argument Pk.
          //    This step can be combined with c.
          // c. If kPresent is true, then
          if (k in O) {
            // i. Let kValue be the result of calling the Get internal
            // method of O with argument Pk.
            kValue = O[k];

            // ii. Call the Call internal method of callback with T as
            // the this value and argument list containing kValue, k, and O.
            callback.call(T, kValue, k, O);
          }
          // d. Increase k by 1.
          k++;
        }
        // 8. return undefined.
      };
    }
    // Setup logger
    if (environment.production || environment?.logs === false) {
      Logger.enableProductionMode();
    }
    const currentApplicationVersion = environment.appVersion;
    // log.error('Current Version : ' + currentApplicationVersion);
    setTimeout(() => {
      if (this.authService.isAuthenticated()) {
        if (environment.signalRConfigured && localStorage.getItem('IsApiNotification') !== 'true') {
          const adminPath = location.pathname.toLocaleLowerCase().search(/admin/g) > -1;
          if (!adminPath) {
            this.signalRService.init();
            //this.realTimeNotificationService.init();
            //this.realTimeNotificationService.subscribeListeners();
            this.OnNotificationSync();
          }
        }
        log.info('setInterval >> this.SetNoficationTimeout()');
        setInterval(() => {
          log.info('setInterval >> this.SetNoficationTimeout() called');
          this.SetNoficationTimeout();
          if (localStorage.getItem('IsApiNotification') === 'true' || environment.signalRConfigured === false) {
            if (localStorage.getItem('lastSyncDateNotify') == null) {
              const date: any = new Date();
              localStorage.setItem('lastSyncDateNotify', date);
            }
            log.debug(' Api notification is ready');
            this.NotificationSend();
          }
        }, environment.NotificationSetting.notificationUpdateInterval);

        setTimeout(() => {
          log.info('setTimeout >> this.SetNoficationTimeout() 5000ms called');
          this.SetNoficationTimeout();
        }, 5000);

        sessionStorage.setItem('loaded', 'true');
      }
      // for away event
      // Here
      //Cannot read properties of undefined (reading 'click') , TypeError: Cannot read properties of undefined (reading 'click')
      let authElements = document.getElementsByClassName('with-auth');
      if (authElements && authElements.length > 0) {
        let element: HTMLElement = document.getElementsByClassName('with-auth')[0] as HTMLElement;
        element.click();
      }
    }, 5000);
  }

  ngAfterViewInit() {
    const script = document.createElement('script');
    let language = localStorage.getItem('language');
    if (language === undefined || language == null) {
      language = 'en';
    }
    // const googleMapUrl =
    //   'https://maps.googleapis.com/maps/api/js?key=AIzaSyCQzBPD81VPXP_Wg79w_ubA4XiuU4_XPaU&language=' + language;
    // script.setAttribute('src', googleMapUrl);
    // const head = document.getElementsByTagName('head')[0];
    // head.appendChild(script);

    this.authService.startLoginStatusTimer();
    this.setupTelephony();
  }

  GetLastResetTimeStamp(): number {
    var lastResetTimeStamp = 0;
    if (this._localStorage) {
      lastResetTimeStamp = parseInt(this._localStorage[this._localStorageKey], 10);
      if (isNaN(lastResetTimeStamp) || lastResetTimeStamp < 0) lastResetTimeStamp = new Date().getTime();
    } else {
      lastResetTimeStamp = this._lastResetTimeStamp;
    }

    return lastResetTimeStamp;
  }

  WriteProgress(msg: string) {
    if (console) log.info(msg);
  }

  showEndSessionDialog() {
    this.dialogService.open(SessionMessageComponent, {
      maskStyleClass: '',
      styleClass: '',
      header: 'Session Info',
      width: '50%',
      closeOnEscape: false,
      closable: false,
      showHeader: false,
    });
  }

  onLogout(e: any) {
    console.log(
      `${moment().toISOString()} onLogout [app.component.ts] line 685 => this.authService.logout() event called`
    );
    this.authService.logout();
  }

  routeDecider() {
    let authData = this.authService.authData;

    if (authData && authData.Features) {
      if (authData.RecoveryCode) {
        this.router.navigate(['/recovery-code']);
        return;
      }

      const features = authData.Features;
      const perm = features.map((item: any) => {
        return item.Name;
      });

      this.ngxPermission.loadPermissions(perm);
      const permissions = this.ngxPermission.getPermissions();
      // console.log(new Date().toLocaleString() + '  ➤  authData ==> ', authData);
      // console.log(new Date().toLocaleString() + '  ➤  permissions ==> ', permissions);
      // console.log(new Date().toLocaleString() + '  ➤  features ==> ', features);
      // const isAdmin = authData?.Admin;
      // const isAgent = authData?.Agent;
      // const isSupervisor = authData?.Supervisor;
      // const isQA = !authData?.Admin && !authData?.Agent && !authData?.Supervisor;
      const isAdmin = authData?.PrimaryApp === 'Backstage';
      const isAgent = authData?.PrimaryApp == 'ConnectHub';
      const isSupervisor = authData?.PrimaryApp === 'Sightline';
      const isQA = authData?.PrimaryApp === 'QA';
      //authData?.QA;
      const agentPath = location.pathname.toLocaleLowerCase().search(/agent/g) > -1;
      const supervisorPath = location.pathname.toLocaleLowerCase().search(/supervisor/g) > -1;
      const insightPath = location.pathname.toLocaleLowerCase().search(/insight/g) > -1;
      const adminPath = location.pathname.toLocaleLowerCase().search(/admin/g) > -1;
      const qaPath = location.pathname.toLocaleLowerCase().search(/QA/g) > -1;

      // console.log(new Date().toLocaleString() + '  ➤  isAgent ==> ', isAgent);
      // console.log(new Date().toLocaleString() + '  ➤  isSupervisor ==> ', isSupervisor);
      // console.log(new Date().toLocaleString() + '  ➤  location.pathname ==> ', location.pathname);
      // console.log(new Date().toLocaleString() + '  ➤  agentPath ==> ', agentPath);
      // console.log(new Date().toLocaleString() + '  ➤  supervisorPath ==> ', supervisorPath);
      //console.log(new Date().toLocaleString() + '  ➤  adminPath ==> ', adminPath);
      //* Initial Route Logic After Login User
      if (isAgent) {
        if (!agentPath && !supervisorPath && !insightPath && !adminPath && !qaPath) {
          this.authService.agentDefaultUrl();
          this.router.navigate([Constants.Apps.Agent.defaultPath]);
        }
      } else if (isSupervisor) {
        this.authService.QADefaultUrl();
        if (!agentPath && !supervisorPath && !insightPath && !adminPath && !qaPath) {
          this.router.navigate([Constants.Apps.Supervisor.defaultPath]);
        }
      } else if (isAdmin) {
        this.authService.backstageDefaultUrl();
        if (!agentPath && !supervisorPath && !insightPath && !adminPath && !qaPath) {
          this.router.navigate([Constants.Apps.Admin.defaultPath]);
        }
      } else if (isQA) {
        this.authService.QADefaultUrl();
        if (!agentPath && !supervisorPath && !insightPath && !adminPath && !qaPath) {
          this.router.navigate([Constants.Apps.QA.defaultPath]);
        }
      } else {
        this.router.navigate([location.pathname]);
      }
      // if (!agentPath && !adminPath && !supervisorPath) {
      //   this.router.navigate([Constants.Apps.Agent.defaultPath]);
      // } else {
      //   this.router.navigate([location.pathname]);
      // }

      // Legendary code, only lagends can understand, that's why commenting it lol.
      // if (isAdmin && isAgent && isSupervisor) {
      //   this.router.navigate([location.pathname]);
      // } else if (isAdmin && isAgent) {
      //   if (agentPath || adminPath) {
      //     this.router.navigate([location.pathname]);
      //   } else {
      //     this.router.navigate(['/admin/dashboard']);
      //   }
      // } else if (isSupervisor && isAgent) {
      //   if (agentPath || supervisorPath) {
      //     this.router.navigate([location.pathname]);
      //   } else {
      //     this.router.navigate(['/supervisor/dashboard']);
      //   }
      // } else if (isSupervisor && isAdmin) {
      //   if (adminPath || supervisorPath) {
      //     this.router.navigate([location.pathname]);
      //   } else {
      //     this.router.navigate(['/admin/dashboard']);
      //   }
      // } else if (isAdmin) {
      //   if (adminPath) {
      //     this.router.navigate([location.pathname]);
      //   } else {
      //     this.router.navigate(['/admin/dashboard']);
      //   }
      // } else if (isSupervisor) {
      //   if (supervisorPath) {
      //     this.router.navigate([location.pathname]);
      //   } else {
      //     this.router.navigate(['/supervisor/dashboard']);
      //   }
      // } else if (isAgent) {
      //   if (agentPath) {
      //     this.router.navigate([location.pathname]);
      //   } else {
      //     this.router.navigate(['/agent/dashboard']);
      //   }
      // }

      // if (isAdmin) {
      //   this.router.navigate([location.pathname]);
      // } else if (isSupervisor) {
      //   this.router.navigate([location.pathname]);
      // } else {
      //   this.router.navigate([location.pathname]);
      // }

      // if (isReporting === -1 && isAdmin === -1) {
      //   const Admin = features.find((x: any) => x.Name === 'Admin');
      //   const Reporting = features.find((x: any) => x.Name === 'Reporting');
      //   if (Reporting) {
      //     this.router.navigate(['/admin']);
      //   } else if (Admin) {
      //     this.router.navigate(['/admin']);
      //   } else {
      //     this.router.navigate(['/unauthorized']);
      //   }
      // }
    }
  }

  // Sending notification from local storage
  NotificationSend() {
    this.permissions = this.ngxPermission.getPermissions();
    this.isPortalTrafficDataPushAllowed = this.permissions[Identifiers.PortalTrafficDataPush] ? true : false;
    if (this.isPortalTrafficDataPushAllowed) {
      if (!this.notificationApiRequestinProcess) {
        this.notificationService.getAllRecoredsAsync().subscribe((record) => {
          const tabSessionId = this.notificationService.sessionId;
          const appNotifyId: any = localStorage.getItem('appNotifyId');
          const notifications = record.filter((rec: any) => {
            return (
              (rec.monitoringType === this.notificationService.routingType &&
                rec.isRead !== true &&
                rec.tabSessionId === tabSessionId) || // Inserted record
              (rec.isRead === true &&
                rec.monitoringType === this.notificationService.routingType &&
                rec.appNotifyId === appNotifyId &&
                rec.tabSessionId === tabSessionId &&
                rec.duration === null &&
                rec.dateTimeExited !== null) || // exit time updated record
              (rec.monitoringType !== this.notificationService.routingType &&
                rec.tabSessionId === tabSessionId &&
                rec.isRead !== true) || // non routing event
              rec.isTimeOut === true
            ); // timeout record
          });

          if (notifications.length > 0) {
            for (let i = 0; i < notifications.length; i++) {
              if (this.notificationService.IsRoutingUpdateRecord(notifications[i])) {
                notifications[i] = this.notificationService.SetUpdateNotificationValues(notifications[i]);
              }
            }

            if (environment.signalRConfigured === false || localStorage.getItem('IsApiNotification') === 'true') {
              this.notificationApiRequestinProcess = true;
              this.realTimeNotificationService.SendApiNotifications(notifications).subscribe(
                (res) => {
                  // console.log(new Date().toLocaleString() + '  ➤  Adding Notification', res);
                  this.notificationApiRequestinProcess = false;
                  this.AddNewNotifications(res);
                },
                (error) => {
                  this.notificationApiRequestinProcess = false;
                }
              );
            } else {
              // if (this.signalRService.ConnectionCurrentState === 'connected') {
              //     this.signalRService.syncNotificationData(notifications);
              // }
              if (this.signalRService.isConnected()) {
                this.signalRService.syncNotificationData(notifications);
              }
            }
          }
        });
      }
    }
  }

  OnNotificationSync() {
    // Getting response from Signal R by sending notification from NotificationSend() method
    this.signalRService.NotificationResponse.subscribe((notifications) => {
      this.UpdateNotification(notifications);
    });

    // On receiving General Notifications
    this.signalRService.GeneralNotificationResponse.subscribe((notification) => {
      if (notification !== '') {
        this.toastService.customInfoToast(notification);
        this.notificationService.addAsync(notification).subscribe(() => {
          this.signalRService.notificationReload.next(true);
        });
      }
    });

    this.signalRService.SingleRStateResponse.subscribe((status) => {
      if (status) {
        this.Interval = setInterval(() => {
          this.NotificationSend();
        }, environment.NotificationSetting.notificationUpdateInterval);
        log.debug('Initalized Signal');
      } else {
        clearInterval(this.Interval);
      }
    });
  }

  UpdateNotification(notifications: any[]) {
    // If any Notification Got from Server then run this
    if (notifications) {
      // Clearing local DB storage
      // if (!this.signalRService.IsFirstNotificationSync) {
      //   this.notificationService.clearAsync().subscribe(e => {
      //    this.AddNewNotifications(notifications);
      //  }, (error) => {});
      // } else {
      this.AddNewNotifications(notifications);
      // this.signalRService.IsFirstNotificationSync = false;
      // }
    }
  }

  SetNoficationTimeout() {
    if (localStorage.getItem('sessionsTab') != null) {
      const sessionData: any = JSON.parse(localStorage.getItem('sessionsTab') || 'null');
      // const appNotifyId = localStorage.getItem('appNotifyId');
      this.notificationService.getAllRecoredsAsync().subscribe((res) => {
        log.info('SetNoficationTimeout() >> sessions length >> {0}', sessionData.length);
        log.info('SetNoficationTimeout() >> res length >> {0}', res.length);

        for (let j = 0; j < sessionData.length; j++) {
          const sessionId = sessionData[j].sessionId;
          const date = sessionData[j].Date;
          for (let i = 0; i < res.length; i++) {
            if (
              res[i].dateTimeAccessed != null &&
              res[i].monitoringType === this.notificationService.routingType &&
              res[i].tabSessionId === sessionId &&
              res[i].dateTimeExited == null
            ) {
              res[i].dateTimeExited = new Date(date);
              res[i].isTimeOut = true;
              this.notificationService.setItem(res[i]);
            } else if (
              res[i].dateTimeAccessed != null &&
              res[i].monitoringType === this.notificationService.routingType &&
              res[i].tabSessionId === sessionId &&
              res[i].dateTimeExited != null &&
              res[i].duration == null
            ) {
              res[i].isTimeOut = true;
              this.notificationService.setItem(res[i]);
            }
          }
        }
      });
    }
  }

  AddNewNotifications(notifications: any[]) {
    // Adding Notifications to local Db storage
    if (!notifications) {
      notifications = [];
    }
    const promises: Promise<Notification>[] = [];
    notifications.forEach((e) => {
      if (e.monitoringType !== this.notificationService.syncDateType) {
        const promise = this.notificationService.addExist(e);
        promises.push(promise);
      } else {
        log.debug('lastSyncDateNotify >> ', e.date);
        localStorage.setItem('lastSyncDateNotify', e.date);
      }
    });

    this.notificationService.getAllRecoredsAsync().subscribe((res: any) => {
      const count = res.reduce((acc: any, cur: any) => (cur.isRead === true ? ++acc : acc), 0);
      const readRecords = res;
      if (count > this.ReadNotificationCount) {
        let breakCounter = 0;
        const stopCounter: number = count - this.ReadNotificationCount;
        for (let i = 0; i < this.ReadNotificationCount; i++) {
          if (breakCounter === stopCounter) {
            break;
          }
          if (readRecords[i].isRead === true) {
            this.notificationService.removeAsync(readRecords[i].id);
            breakCounter++;
          }
        }
      }
      // set unread records isread equal to true to avoid them in sending next call
      for (let i = 0; i < res.length; i++) {
        // tslint:disable-next-line:max-line-length
        if (
          readRecords &&
          readRecords.length &&
          readRecords[i].isRead === false &&
          readRecords[i].monitoringType !== this.notificationService.routingType &&
          readRecords[i].page !== 'Login'
        ) {
          readRecords[i].isRead = true;
          this.notificationService.setItem(readRecords[i]);
        }
      }
    });

    // Promise.all(promises).then(d => {
    //   // Refreshing Notification modal to update notifications from Local storage
    //   this.signalRService.notificationReload.next(true);
    // });

    forkJoin(promises).subscribe((values) => {
      // Refreshing Notification modal to update notifications from Local storage
      this.signalRService.notificationReload.next(true);
      log.debug('AddNewNotifications Result:', values);
    });
  }
  onReload() {
    window.location.reload();
  }
  async setupTelephony() {
    if (this.authService.isAuthenticated()) {
      this.authService.onlogin.next('LoggedIn');
      let user = this.authService.authData;
      const features = user.Features;
      const isAgentCallPermission = features.find((x: any) => x.Name === 'agent_calls');
      const isAgentChatPermission = features.find((x: any) => x.Name === 'agent_chat');

      if (isAgentCallPermission && user.Campaigns?.length > 0) {
        let campaign = user.Campaigns[0];
        const campaign_settings = await this.campaignService.getPrimaryCampaignSettings(campaign.Id);
        this.telephonyProvider.voice.init(null, campaign_settings);
        this.providerService.setProviderData(campaign_settings);
        this.integrationService.setIntegrationStatus(campaign_settings);
      }
      if (isAgentChatPermission) {
        this.conversationService.getAgentConversations();
      }
    }
  }
  async markCallForceDispose(callSid: string | null) {
    if (callSid) {
      localStorage.setItem('isFD', 'true');
      log.debug('Active call found marking it as force disposed');
      let fd_lead: any = JSON.parse(localStorage.getItem('fd_leadData') ?? '{}');
      if (Object.keys(fd_lead).length == 0) return;
      const token = await firstValueFrom(this.authService.getCurrentUserToken());
      fetch(`${environment.api.url}${environment.api.server}${Constants.APIS.CALL.UPDATE}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(fd_lead),
        keepalive: true,
      });
      localStorage.removeItem('activeCallSid');
      localStorage.removeItem('fd_leadData');
    }
  }
  async sendAwayEvent(status: string) {
    const date = moment().toISOString();
    let lastStatus: any = window.localStorage.getItem('last_status');
    if (lastStatus) {
      lastStatus = JSON.parse(lastStatus);
      window.localStorage.setItem('last_status', JSON.stringify({ status: lastStatus.status, time: date }));
    }
    const token = await firstValueFrom(this.authService.getCurrentUserToken());
    const body = {
      Status: status,
      UserId: this.authService.authData.Id,
      Version: '1.0.0',
      Campaigns: this.authService.authData.Campaigns,
      Date: date,
    };
    fetch(`${environment.api.url}${environment.api.server}/userstatushistory`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
      keepalive: true,
    });
  }
}
